export default {
      id: "arrow-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "app/svg/sprite.svg#arrow",
      toString: function () {
        return this.url;
      }
    }